import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './tire-tread-model.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const TireTreadModelDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const tireTreadModelEntity = useAppSelector(state => state.tireTreadModel.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tireTreadModelDetailsHeading">
          <Translate contentKey="fleetSenseApp.tireTreadModel.detail.title">TireTreadModel</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{tireTreadModelEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.tireTreadModel.name">Name</Translate>
            </span>
          </dt>
          <dd>{tireTreadModelEntity.name}</dd>
          <dt>
            <span id="specification">
              <Translate contentKey="fleetSenseApp.tireTreadModel.specification">Specification</Translate>
            </span>
          </dt>
          <dd>{tireTreadModelEntity.specification}</dd>
          <dt>
            <span id="groove">
              <Translate contentKey="fleetSenseApp.tireTreadModel.groove">Groove</Translate>
            </span>
          </dt>
          <dd>{tireTreadModelEntity.groove}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.tireTreadModel.tireTreadManufacturer">Tire Tread Manufacturer</Translate>
          </dt>
          <dd>{tireTreadModelEntity.tireTreadManufacturer ? tireTreadModelEntity.tireTreadManufacturer.name : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.tireTreadModel.company">Company</Translate>
          </dt>
          <dd>{tireTreadModelEntity.company ? tireTreadModelEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/tire-tread-model" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tire-tread-model/${tireTreadModelEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TireTreadModelDetail;
